import * as yup from 'yup';
import docs from './attachments/specific';
import {
  parentesco,
  medicos,
  consentimentoDadosSensiveis,
  cpfResponsavelLegal,
  nomeDoTutor,
  adiantamentoQuinzenal,
  acessoContraCheque,
  // acessoJornalForluz,
  consentimentoDescontoFolha,
  aceiteInss,
  declaracaoVeracidade,
  consentimentoAcertoFinanceiro,
} from './utils/rulesByKey';

export const ContConjulgadaSchema = () => {
  const dadosSensiveis = consentimentoDadosSensiveis();

  return yup.object({
    ...parentesco,
    ...cpfResponsavelLegal,
    ...nomeDoTutor,
    ...medicos('medicoPerito'),
    ...medicos('medicoAssistente'),
    ...adiantamentoQuinzenal,
    ...acessoContraCheque,
    // ...acessoJornalForluz,
    ...consentimentoDescontoFolha,
    ...consentimentoAcertoFinanceiro,
    ...dadosSensiveis,
    ...declaracaoVeracidade,
    ...docs.ContConjulgadaDocs.rules,
    ...aceiteInss,
  });
};

export const ContConjulgadaInitialValues = {
  parentesco: '',
  cpfResponsavelLegal: '',
  nomeDoTutor: '',
  medicoPerito: '',
  medicoAssistente: '',
  adiantamentoQuinzenal: '',
  acessoContraCheque: '',
  // acessoJornalForluz: '',
  consentimentoDescontoFolha: false,
  consentimentoDadosSensiveis: false,
  consentimentoAcertoFinanceiro: false,
  aceiteInss: false,
  declaracaoVeracidade: false,
  ...docs.ContConjulgadaDocs.initialValues,
};

export const ContConjulgadaDocs = {
  ...docs.ContConjulgadaDocs.docs,
};
